var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"test-wrap"},[_c('div',{staticClass:"iframe-wrap",style:({ top: _vm.contentTop + 'px' })},[_c('iframe',{attrs:{"id":"test","src":_vm.url,"height":_vm.height}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }